module.exports = __webpack_public_path__ + "static/media/quinoa.bbeffa3f.jpg";